module.exports = __webpack_public_path__ + "images/elon-musk1.dcf9a.png";